"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Slider = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useGlobalStyles = require("../../styles/global/useGlobalStyles");

var _slider = require("./slider.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Slider = function Slider(props) {
  (0, _useGlobalStyles.useGlobalStyles)();
  var classes = (0, _slider.useStyles)(props);
  var content = props.content;
  var slideIndex = 0;

  var slideShow = function slideShow() {
    var counter;
    var slides = document.getElementsByClassName(classes.fade);
    var dots = document.getElementsByClassName(classes.dot);

    for (counter = 0; counter < slides.length; counter++) {
      if (slides[counter].classList.contains(classes.block)) slides[counter].classList.remove(classes.block);
    }

    slideIndex++;

    if (slideIndex > slides.length) {
      slideIndex = 1;
    }

    for (counter = 0; counter < dots.length; counter++) {
      dots[counter].className = dots[counter].className.replace(classes.active, "");
    }

    slides[slideIndex - 1] ? slides[slideIndex - 1].className += " ".concat(classes.block) : "";
    dots[slideIndex - 1] ? dots[slideIndex - 1].className += " ".concat(classes.active) : "";
    setTimeout(slideShow, props.delay * 1000);
  };

  slideShow();
  var slides = content.contents.map(function (slide, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(classes.fade, " ").concat(classes.slides),
      key: index
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(classes.center)
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: slide.image,
      className: "".concat(classes.image)
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(classes.center)
    }, /*#__PURE__*/_react["default"].createElement("h3", {
      className: "".concat(classes.title)
    }, slide.title)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(classes.center)
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: "".concat(classes.text)
    }, slide.description)));
  });

  var sliderCounter = /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classes.sliderCounter)
  }, content.contents.map(function (slide) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "".concat(classes.dot),
      key: slide.id
    });
  }));

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classes.sliderBox)
  }, slides, sliderCounter);
};

exports.Slider = Slider;
Slider.propTypes = {
  /** Content type */
  content: _propTypes["default"].object,

  /** Content type */
  textColor: _propTypes["default"].oneOf(["father", "fatherHover", "mother", "motherHover", "ghost", "swan", "hare", "whale", "wolf", "night", "sky", "oceans", "fire", "fox", "bee", "kiwi"]),

  /** Content type */
  delay: _propTypes["default"].number
};
Slider.defaultProps = {
  delay: 8,
  textColor: "night"
};